<template>
    <div>
        <!-- Plano Atual (somente edição) -->
        <Panel v-if="modo === 'edicao'" header="Plano Atual" :toggleable="true" class="p-mb-4">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-4">
                    <label>Equipamentos</label>
                    <InputText :value="planoAtual.equipamentos" disabled />
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Usuários</label>
                    <InputText :value="planoAtual.usuarios" disabled />
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Operadores</label>
                    <InputText :value="planoAtual.operadores" disabled />
                </div>
            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col-12 p-md-4">
                    <label>Pacote</label>
                    <InputText :value="planoAtual.descricaoPacote" disabled />
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Valor Mensal</label>
                    <InputText :value="'R$ ' + formatarValor(planoAtual.valorMensal)" disabled />
                </div>
            </div>
            <h6 class="p-mt-4">Adicionais</h6>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-4">
                    <label>Valor Equipamento Adicional</label>
                    <InputText :value="'R$ ' + formatarValor(planoAtual.valorEquipamentoAdicional)" disabled />
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Valor Usuário Adicional</label>
                    <InputText :value="'R$ ' + formatarValor(planoAtual.valorUsuarioAdicional)" disabled />
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Valor Operador Adicional</label>
                    <InputText :value="'R$ ' + formatarValor(planoAtual.valorOperadorAdicional)" disabled />
                </div>
            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col-12 p-md-4">
                    <label>Equipamentos Adicionais</label>
                    <InputText :value="planoAtual.equipamentosAdicionais || 0" disabled />
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Usuários Adicionais</label>
                    <InputText :value="planoAtual.usuariosAdicionais || 0" disabled />
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Operadores Adicionais</label>
                    <InputText :value="planoAtual.operadoresAdicionais || 0" disabled />
                </div>
            </div>
            <div class="p-d-flex p-jc-end p-mt-4">
                <h5>Total do Plano: R$ {{ formatarValor(totalPlanoAtual) }}</h5>
            </div>
        </Panel>

        <!-- Formulário de Plano (novo ou atualização) -->
        <Panel :header="modo === 'edicao' ? 'Atualizar Plano' : 'Plano'" :toggleable="true" class="p-mb-4">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-4">
                    <label>Equipamentos</label>
                    <InputText :value="planoConfig.equipamentos" disabled />
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Usuários</label>
                    <InputText :value="planoConfig.usuarios" disabled />
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Operadores</label>
                    <InputText :value="planoConfig.operadores" disabled />
                </div>
            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col-12 p-md-12">
                    <label>Pacote <span class="p-error">*</span></label>
                    <div class="p-d-flex p-ai-center">
                        <Dropdown v-model="pacoteSelecionado" :options="opcoesPacotes" optionLabel="label" placeholder="Selecione o pacote" :class="{'p-invalid': enviado && !pacoteSelecionado}" style="flex: 1" />
                        <span v-if="pacoteSelecionado" class="p-ml-3"><b>R$ {{ formatarValor(pacoteSelecionado.planValue) }}</b></span>
                    </div>
                    <small v-if="enviado && !pacoteSelecionado" class="p-error">Campo obrigatório.</small>
                </div>

            </div>

            <h6 class="p-mt-4">Adicionais</h6>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-4">
                    <label>Valor Equipamento Adicional</label>
                    <InputText :value="'R$ ' + formatarValor(planoConfig.valorEquipamentoAdicional)" disabled />
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Valor Usuário Adicional</label>
                    <InputText :value="'R$ ' + formatarValor(planoConfig.valorUsuarioAdicional)" disabled />
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Valor Operador Adicional</label>
                    <InputText :value="'R$ ' + formatarValor(planoConfig.valorOperadorAdicional)" disabled />
                </div>
            </div>
            <div class="p-fluid p-formgrid p-grid p-mt-2">
                <div class="p-field p-col-12 p-md-4">
                    <label>Equipamentos Adicionais</label>
                    <InputNumber v-model="adicionais.equipamentos" :min="0" showButtons />
                    <small class="p-d-block p-mt-1">Subtotal: R$ {{ formatarValor(adicionais.equipamentos * planoConfig.valorEquipamentoAdicional) }}</small>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Usuários Adicionais</label>
                    <InputNumber v-model="adicionais.usuarios" :min="0" showButtons />
                    <small class="p-d-block p-mt-1">Subtotal: R$ {{ formatarValor(adicionais.usuarios * planoConfig.valorUsuarioAdicional) }}</small>
                </div>
                <div class="p-field p-col-12 p-md-4">
                    <label>Operadores Adicionais</label>
                    <InputNumber v-model="adicionais.operadores" :min="0" showButtons />
                    <small class="p-d-block p-mt-1">Subtotal: R$ {{ formatarValor(adicionais.operadores * planoConfig.valorOperadorAdicional) }}</small>
                </div>
            </div>

            <div class="p-d-flex p-jc-end p-mt-4">
                <h5>Total do Plano: R$ {{ formatarValor(totalPlano) }}</h5>
            </div>
            <div v-if="modo === 'edicao'" class="p-d-flex p-jc-end p-mt-3">
                <Button label="Salvar" icon="pi pi-save" @click="salvar" :loading="enviando" />
            </div>
        </Panel>
    </div>
</template>

<script>
import ClienteIKAcessoService from '@/service/ClienteIKAcessoService';
import PlanoIKAcessoService from '@/service/PlanoIKAcessoService';
import { exibirMensagem } from '@/global';

export default {
    props: {
        modo: { type: String, default: 'novo' },
        clienteId: { type: [String, Number], default: null },
        initialData: { type: Object, default: null }
    },
    data() {
        return {
            enviado: false,
            enviando: false,
            pacoteSelecionado: null,
            opcoesPacotes: [
                { label: 'Acesso', value: 'ACESSO', planValue: null },
                { label: 'Acesso e Controle de Refeição', value: 'ACESSO_REF', planValue: null },
                { label: 'Acesso e Escola', value: 'ACESSO_ESCOLA', planValue: null },
                { label: 'Acesso e Controle de Refeição e Escola', value: 'ACESSO_REF_ESCOLA', planValue: null }
            ],
            planoConfig: {
                id: null,
                equipamentos: 0,
                usuarios: 0,
                operadores: 0,
                valorMensalAcesso: 0,
                valorMensalAcessoRef: 0,
                valorMensalAcessoEscola: 0,
                valorMensalAcessoRefEscola: 0,
                valorEquipamentoAdicional: 0,
                valorUsuarioAdicional: 0,
                valorOperadorAdicional: 0
            },
            planoAtual: {
                id: null,
                equipamentos: 0,
                usuarios: 0,
                operadores: 0,
                descricaoPacote: null,
                valorMensal: 0,
                valorEquipamentoAdicional: 0,
                valorUsuarioAdicional: 0,
                valorOperadorAdicional: 0,
                dataExpiracao: null,
                equipamentosAdicionais: 0,
                usuariosAdicionais: 0,
                operadoresAdicionais: 0
            },
            adicionais: {
                equipamentos: 0,
                usuarios: 0,
                operadores: 0
            }
        };
    },
    computed: {
        totalPlanoAtual() {
            const valorEquip = (this.planoAtual.equipamentosAdicionais || 0) * (this.planoAtual.valorEquipamentoAdicional || 0);
            const valorUsuarios = (this.planoAtual.usuariosAdicionais || 0) * (this.planoAtual.valorUsuarioAdicional || 0);
            const valorOperadores = (this.planoAtual.operadoresAdicionais || 0) * (this.planoAtual.valorOperadorAdicional || 0);
            return (this.planoAtual.valorMensal || 0) + valorEquip + valorUsuarios + valorOperadores;
        },
        totalPlano() {
            const valorEquip = this.adicionais.equipamentos * (this.planoConfig.valorEquipamentoAdicional || 0);
            const valorUsuarios = this.adicionais.usuarios * (this.planoConfig.valorUsuarioAdicional || 0);
            const valorOperadores = this.adicionais.operadores * (this.planoConfig.valorOperadorAdicional || 0);
            const valorPacote = this.pacoteSelecionado ? (this.pacoteSelecionado.planValue || 0) : 0;
            return valorPacote + valorEquip + valorUsuarios + valorOperadores;
        }
    },
    watch: {
        initialData(newVal) {
            if (newVal) this.planoAtual = { ...this.planoAtual, ...newVal };
        }
    },
    methods: {
        formatarValor(valor) {
            if (valor == null) return '0,00';
            return Number(valor).toFixed(2).replace('.', ',');
        },
        formatarData(data) {
            if (!data) return '';
            const d = new Date(data);
            return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
        },
        validar() {
            this.enviado = true;
            return !!(this.pacoteSelecionado);
        },
        getData() {
            return {
                id: this.planoConfig.id,
                equipamentos: this.planoConfig.equipamentos,
                usuarios: this.planoConfig.usuarios,
                operadores: this.planoConfig.operadores,
                valorMensal: this.pacoteSelecionado ? this.pacoteSelecionado.planValue : null,
                descricaoPacote: this.pacoteSelecionado ? this.pacoteSelecionado.label : null,
                valorEquipamentoAdicional: this.planoConfig.valorEquipamentoAdicional,
                valorUsuarioAdicional: this.planoConfig.valorUsuarioAdicional,
                valorOperadorAdicional: this.planoConfig.valorOperadorAdicional,
                equipamentosAdicionais: this.adicionais.equipamentos,
                usuariosAdicionais: this.adicionais.usuarios,
                operadoresAdicionais: this.adicionais.operadores
            };
        },
        salvar() {
            if (!this.validar()) {
                this.$toast.add({ severity: 'warn', summary: 'Atenção', detail: 'Preencha todos os campos obrigatórios.', life: 3000 });
                return;
            }
            this.enviando = true;
            const novoPlano = this.getData();
            this.clienteService.alterarPlanoConta(this.clienteId, novoPlano)
                .then(() => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Plano atualizado com sucesso.', life: 3000 });
                    this.planoAtual = { ...this.planoAtual, ...novoPlano };
                })
                .catch(erro => { exibirMensagem(this, erro); })
                .finally(() => { this.enviando = false; });
        },
        buscarConfiguracaoPlano() {
            this.planoService.buscarAtual()
                .then(resp => {
                    this.planoConfig = resp.data;
                    const mapa = {
                        'ACESSO': resp.data.valorMensalAcesso,
                        'ACESSO_REF': resp.data.valorMensalAcessoRef,
                        'ACESSO_ESCOLA': resp.data.valorMensalAcessoEscola,
                        'ACESSO_REF_ESCOLA': resp.data.valorMensalAcessoRefEscola
                    };
                    this.opcoesPacotes = this.opcoesPacotes.map(op => ({
                        ...op,
                        planValue: mapa[op.value] != null ? mapa[op.value] : null
                    }));
                })
                .catch(erro => { exibirMensagem(this, erro); });
        }
    },
    created() {
        this.clienteService = new ClienteIKAcessoService();
        this.planoService = new PlanoIKAcessoService();
    },
    mounted() {
        this.buscarConfiguracaoPlano();
        if (this.initialData) this.planoAtual = { ...this.planoAtual, ...this.initialData };
    }
};
</script>
